import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { PersistGate } from 'redux-persist/integration/react';
import {store, persistor} from './store/store'
import {Provider} from 'react-redux'

//Multi language implementation
import i18n from "i18next";
import {  initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    fallbackLng: "en",
    detection: {
      order: [
        "cookie",
        "localStorage",
        "htmlTag",
        "path",
        "subdomain",
        "querystring",
      ],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/Languages/{{lng}}/translation.json",
    },
    react: { useSuspense: false },
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor} >
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

